import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
  tone?: 'dark' | 'light';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  tone = 'dark'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto items-center' : 'text-left items-start';
  const titleColor = tone === 'dark' ? 'text-forest-800' : 'text-cream-50';
  const subColor = tone === 'dark' ? 'text-forest-700/70' : 'text-cream-100/75';
  return <div className={`flex max-w-3xl flex-col gap-4 ${alignment}`} data-id="element-165" data-mp="glavlk3klwf0">
      {eyebrow ? <span className={`text-sm font-semibold ${tone === 'dark' ? 'text-ember-500' : 'text-ember-400'}`} data-id="element-166" data-mp="1shg3yoatgac">
          {eyebrow}
        </span> : null}
      <h2 className={`font-display text-3xl font-bold leading-tight sm:text-4xl lg:text-[2.75rem] ${titleColor}`} data-id="element-167" data-mp="uh4urbejl7ex">
        {title}
      </h2>
      {subtitle ? <p className={`text-lg leading-relaxed ${subColor}`} data-id="element-168" data-mp="1t961xk46z1e2">{subtitle}</p> : null}
    </div>;
}